(function($) {
    $.fn.fixSlickSliderButtonTranslations = function() {
        this.each(function() {
            var $this = $(this),

                enableTranslationOnSlickDots = function() {
                    if ($().isWelshPage()) {
                        var slickDots = $this.find('.slick-dots button');
                        slickDots.each(function() {
                            var slickDotsAriaLabel = $(this).attr('aria-label');
                            slickDotsAriaLabel = slickDotsAriaLabel.replace('of', 'o');
                            $(this).attr('aria-label', slickDotsAriaLabel);
                        });
                    }
                },

                enableTranslationOnSlickDotsAfterSlideChange = function() {
                    $this.on('afterChange', function(event, slick, currentSlide, nextSlide) {
                        setTimeout(function() {
                            enableTranslationOnSlickDots();
                        }, 100);
                    });
                };

            enableTranslationOnSlickDots();
            enableTranslationOnSlickDotsAfterSlideChange();
        });
        return this;
    };
}(jQuery));
